import { Skeleton } from "@/components/ui/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { BreakdownRow } from "../../api/statsApi";

interface BreakdownTableProps {
  rows: BreakdownRow[];
  isLoading: boolean;
  labelHeader: string;
  valueHeader: string;
}

export const BreakdownTable = ({
  rows,
  isLoading,
  labelHeader,
  valueHeader,
}: BreakdownTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{labelHeader}</TableHead>
          <TableHead className="text-right">{valueHeader}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          Array.from({ length: 5 }).map((_, idx) => (
            <TableRow key={`skeleton-${idx}`}>
              <TableCell>
                <Skeleton className="h-4 w-3/4" />
              </TableCell>
              <TableCell className="text-right">
                <Skeleton className="ml-auto h-4 w-16" />
              </TableCell>
            </TableRow>
          ))
        ) : rows.length === 0 ? (
          <TableRow>
            <TableCell
              colSpan={2}
              className="text-center text-muted-foreground"
            >
              Sin datos
            </TableCell>
          </TableRow>
        ) : (
          rows.map((row) => (
            <TableRow key={row.label}>
              <TableCell>{row.label}</TableCell>
              <TableCell className="text-right tabular-nums">
                {row.count.toLocaleString("es-AR")}
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};
